import { UseMutationOptions } from "@tanstack/react-query";

import { graphql } from "lib/generated/app-service-gql";
import {
  ProcessToneOfVoiceDocumentMutation,
  ProcessToneOfVoiceDocumentMutationVariables,
} from "lib/generated/app-service-gql/graphql";
import { useGraphQlMutation } from "../useGraphQlClient";

const processToneOfVoiceDocument = graphql(`
  mutation processToneOfVoiceDocument($input: ProcessToneOfVoiceDocumentRequest!) {
    processToneOfVoiceDocument(input: $input) {
      processingId
    }
  }
`);

export function useProcessToneOfVoiceDocument(
  options?: UseMutationOptions<
    ProcessToneOfVoiceDocumentMutation,
    unknown,
    ProcessToneOfVoiceDocumentMutationVariables,
    unknown
  >,
) {
  const { data, ...rest } = useGraphQlMutation(processToneOfVoiceDocument, options);

  return { data: data?.processToneOfVoiceDocument, ...rest };
}
